import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const assignmentQuestionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentQuestions: builder.query<
      any,
      { data: PaginateQuery; assignmentId: string }
    >({
      query: ({ data, assignmentId }) => ({
        url: buildPaginationQueryString(
          data,
          `/api/assignment-question/${assignmentId}/assignment/all`,
        ),
      }),
      providesTags: ["Paginated-Assignment-Questions"],
    }),
    getAssignmentQuestion: builder.query<any, string>({
      query: (id) => ({ url: `/api/assignment-question/${id}` }),
      providesTags: ["AssignmentQuestion"],
    }),
    addAssignmentQuestion: builder.mutation<
      any,
      { assignmentId: string; data: any }
    >({
      query: ({ assignmentId, data }) => ({
        url: `/api/assignment-question/${assignmentId}/assignment`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "Paginated-Assignment-Questions",
        "Paginated-Lecture-Assignment",
      ],
    }),
    updateAssignmentQuestion: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/assignment-question/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "AssignmentQuestion",
        "Paginated-Assignment-Questions",
        "Paginated-Lecture-Assignment",
      ],
    }),
    deleteAssignmentQuestion: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/assignment-question/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "Paginated-Assignment-Questions",
        "Paginated-Lecture-Assignment",
      ],
    }),
    toggleAssignmentQuestionState: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/assignment-question/toggle-state/${id}`,
        method: "PATCH",
        body: {},
      }),
      invalidatesTags: ["AssignmentQuestion", "Paginated-Assignment-Questions"],
    }),
  }),
});

export const {
  useGetAssignmentQuestionsQuery,
  useGetAssignmentQuestionQuery,
  useAddAssignmentQuestionMutation,
  useUpdateAssignmentQuestionMutation,
  useDeleteAssignmentQuestionMutation,
  useToggleAssignmentQuestionStateMutation,
} = assignmentQuestionApi;
